import React from 'react';

import { showModal } from 'modal.react.js';

import area from 'components/shared/GlobalModalArea/area';
import useLocalStorage from 'hooks/useLocalStorage';

import MultipleTabsModal from './index';

const MT_VIEWED = 'multipleTabsViewedProposals';

export const useMultipleTabsModal = (proposalId: string, shouldBeShown: boolean) => {
  const [viewedProposals, setViewedProposals] = useLocalStorage(MT_VIEWED, []);

  if (!shouldBeShown || !proposalId || viewedProposals.includes(proposalId)) {
    return null;
  }

  showModal<boolean>(area, (res) => <MultipleTabsModal onClose={() => res(true)} />).then(() =>
    setViewedProposals([...viewedProposals, proposalId]),
  );
};

export default useMultipleTabsModal;
